import { quizDetailsActionTypes } from './Constants';

export function getQuizDetails(data) {
	return {
		type: quizDetailsActionTypes.GET_QUIZ_DETAILS_REQUEST,
		payload: { data },
	};
}

export function getQuizDetailsSuccess(data) {
	return {
		type: quizDetailsActionTypes.GET_QUIZ_DETAILS_SUCCESS,
		payload: { data },
	};
}

export function getQuizDetailsError() {
	return {
		type: quizDetailsActionTypes.GET_QUIZ_DETAILS_ERROR,
	};
}

export function duplicateQuiz(data) {
	return {
		type: quizDetailsActionTypes.DUPLICATE_USER_QUIZ_REQUEST,
		payload: { data },
	};
}

export function duplicateQuizSuccess() {
	return {
		type: quizDetailsActionTypes.DUPLICATE_USER_QUIZ_SUCCESS,
	};
}

export function duplicateQuizError() {
	return {
		type: quizDetailsActionTypes.DUPLICATE_USER_QUIZ_ERROR,
	};
}

export function deleteQuiz(data) {
	return {
		type: quizDetailsActionTypes.DELETE_USER_QUIZ_REQUEST,
		payload: { data },
	};
}

export function deleteQuizSuccess() {
	return {
		type: quizDetailsActionTypes.DELETE_USER_QUIZ_SUCCESS,
	};
}

export function deleteQuizError() {
	return {
		type: quizDetailsActionTypes.DELETE_USER_QUIZ_ERROR,
	};
}
